const CHAT_TYPE = {
  GROUP_CHAT: 'GROUP_CHAT',
  SINGLE_CHAT: 'SINGLE_CHAT',
  REPORT_CHAT: 'REPORT_CHAT',
  CLIENTS_CHAT: 'CLIENTS_CHAT',
}

export { CHAT_TYPE }
